<div [innerHTML]="(showFlag ? text : trimmedText) | noHtml"></div>
<button
  class="show-button"
  (click)="showFlag = !showFlag"
  *ngIf="isShowMoreLabelShown && this.text.length > this.trimmedText.length"
>
  {{ 'button.show' + (showFlag ? 'Less' : 'More') | loc }}
</button>
